export const getPowerBiUrl = `
  query GetPowerBiUrl {
    powerBiUrl
  }
`;
